export default "__VITE_ASSET__CyZRjLNb__"